var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "widthFull " },
    [
      _c("div", { staticClass: "container  bgWhite " }, [
        _vm.brand == "CHEBONUS" && !_vm.isAuthenticated
          ? _c("div", { staticClass: "row justify-content-center " }, [
              _c(
                "div",
                {
                  staticClass:
                    "col-md-4 pb-3 mb-5 text-md-left text-center pl-md-5 pt-5 order-2 order-md-1"
                },
                [
                  _vm._m(0),
                  _vm._v(" "),
                  _c("h5", [
                    _vm._v(
                      "\n            Accedi a Vaillant CheBonus e fornisci al tuo cliente i vantaggi dello sconto in fattura!\n          "
                    )
                  ]),
                  _vm._v(" "),
                  !_vm.isAuthenticated
                    ? _c(
                        "router-link",
                        {
                          staticClass:
                            "btn btn-primary  mr-md-4 mt-5 btnYellow",
                          attrs: { to: "/registration" }
                        },
                        [_vm._v("\n            Registrati subito!\n          ")]
                      )
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _vm._m(1)
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.brand == "HAPPYBONUS" && !_vm.isAuthenticated
          ? _c("div", { staticClass: "row justify-content-center " }, [
              _c(
                "div",
                {
                  staticClass:
                    "col-md-4 pb-3 mb-5 text-md-left text-center pl-md-5 pt-5 order-2 order-md-1"
                },
                [
                  _vm._m(2),
                  _vm._v(" "),
                  _c("h5", [
                    _vm._v(
                      "\n            Accedi a Hermann Saunier Duval HappyBonus e fornisci al tuo cliente i vantaggi dello sconto in fattura!\n\n          "
                    )
                  ]),
                  _vm._v(" "),
                  !_vm.isAuthenticated
                    ? _c(
                        "router-link",
                        {
                          staticClass:
                            "btn btn-primary  mr-md-4 mt-5 btnHSDRed",
                          attrs: { to: "/registration" }
                        },
                        [_vm._v("\n            Registrati subito!\n          ")]
                      )
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _vm._m(3)
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm._m(4)
      ]),
      _vm._v(" "),
      _c("areaRiservata")
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h3", { staticClass: "mt-md-5 pt-md-5" }, [
      _vm._v("\n            Installa Vaillant e attiva\n            "),
      _c("br"),
      _vm._v("CheBonus!\n          ")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "col-md-8 headerBack order-1 order-md-2" },
      [
        _c("img", {
          staticClass: "imf-fluid widthFull",
          attrs: { src: require("../../assets/images/newHome.jpg") }
        })
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h3", { staticClass: "mt-md-5 pt-md-5" }, [
      _vm._v("\n            HappyBonus\n            "),
      _c("br")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "col-md-8 headerBack order-1 order-md-2 pl-0 pr-0" },
      [
        _c("img", {
          staticClass: "imf-fluid widthFull",
          attrs: { src: require("../../assets/images/newHomeHSD.jpg") }
        })
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-12 pr-0 pl-0 csmrtop" }, [
      _c("div", { staticClass: "row justify-content-center " }, [
        _c("img", {
          staticClass: "img-fluid widthFull",
          attrs: { src: require("../../assets/images/wave.png") }
        })
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-67f3a69c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-67f3a69c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home/index.vue
// module id = null
// module chunks = 